import React, { useState } from "react";
import { IMeetupDataType } from "../../config/types/MeetupDataType";
import { ModalBody, ModalFooter, ModalHeader } from "../ui/modal";
import Tab from "../ui/tab";
import usePersonalMeetup from "./usePersonalMeetup";
import usePersonalMeetupActions from "./usePersonalMeetupActions";

interface IPersonalMeetupContent {
  onClose(): void;
  data: IMeetupDataType;
}

const PersonalMeetupContent: React.FC<IPersonalMeetupContent> = ({
  data,
  onClose,
}) => {
  const [Active, setActive] = useState(0);

  const { title, items, label } = usePersonalMeetup(data);
  const { modalButton } = usePersonalMeetupActions(data);

  return (
    <>
      <ModalHeader label={label} title={title} />
      <ModalBody>
        <Tab
          items={items}
          active={Active}
          type="vertical"
          onTabClick={(id) => setActive(id)}
        >
          {items[Active]["content"]}
        </Tab>
      </ModalBody>
      <ModalFooter>{modalButton(onClose)}</ModalFooter>
    </>
  );
};

export default PersonalMeetupContent;
